import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import theme from '../../styles/theme';
import useLinkStyles from '../../styles/useLinkStyles';
import { TextLinkInline, } from '../TextLinkInline/index';
const maximumNumberOfCharacters = 20;
const breadcrumbsStyles = css `
  color: ${theme.colors.accent600};
  display: flex;
`;
const getCrumbText = ({ isLastCrumb = false, text = '', }) => ((isLastCrumb
    || text.length <= maximumNumberOfCharacters)
    ? text
    : (text
        .slice(0, maximumNumberOfCharacters)
        .concat('...')));
const Breadcrumbs = ({ crumbs, }) => {
    const linkStyles = useLinkStyles({
        size: 'small',
        type: 'primary',
    });
    const crumbStyles = useMemo(() => (css `
        ${linkStyles}
        margin-right: ${theme.spacing.x3};

        &:not(:last-child)::after {
          content: '|';
          margin-left: ${theme.spacing.x3};
        }
      `), [
        linkStyles,
    ]);
    const modifiedCrumbs = useMemo(() => (crumbs
        .map(({ label, onClick, url, }, index) => {
        const crumbText = (getCrumbText({
            isLastCrumb: index === (crumbs.length - 1),
            text: label,
        }));
        return (_jsx("div", Object.assign({ css: crumbStyles }, { children: _jsx(TextLinkInline, { hasUnderline: false, hasUnderlineOnHover: true, href: url, onClick: onClick, text: crumbText }) }), label));
    })), [
        crumbs,
        crumbStyles,
    ]);
    return (_jsx("nav", Object.assign({ css: breadcrumbsStyles }, { children: modifiedCrumbs })));
};
const MemoizedBreadcrumbs = memo(Breadcrumbs);
export { MemoizedBreadcrumbs as Breadcrumbs };
// MC-1068 Temporary hack for Storybook.
export default Breadcrumbs;
